<template>
    <div class="depoimentos">
        <div class="row justify-content-center ">
            <div class="col-12 col-md-8 text-center">
                <span class="txt-p txt-size-20 txt-roxo-1 txt-w-5">{{labels[0]}}</span>
            </div>
        </div>
        <div class="row justify-content-center section-depoimentos">
            <div class="col-md-3 d-flex align-items-center">
                <div class="card-depoimento-p mt-4" v-if="anterior != null">
                    <i class="icone-citacao fas fa-quote-left"></i>
                    <p class="depoimento">
                        {{anterior.dsDepoimento}}
                    </p>
                    <div class="fixa-bot">
                        <p class="autor">{{anterior.nmUsuario}}</p>
                        <p class="cargo">{{anterior.dsCargo}}</p>
                    </div>

                </div>
            </div>
            <div class="col-12 col-md-6 text-center">                

                <div class="card-depoimento mt-4" v-if="ativo != null">
                    <i class="icone-citacao fas fa-quote-left"></i>
                    <p class="depoimento">
                        {{ativo.dsDepoimento}}
                    </p>
                    <div class="fixa-bot">
                        <p class="autor">{{ativo.nmUsuario}}</p>
                        <p class="cargo">{{ativo.dsCargo}}</p>
                    </div>

                </div>
            </div>
            <div class="col-md-3 d-flex align-items-center">
                <div class="card-depoimento-p mt-4" v-if="proximo != null">
                    <i class="icone-citacao fas fa-quote-left"></i>
                    <p class="depoimento">
                        {{proximo.dsDepoimento}}
                    </p>
                    <div class="fixa-bot">
                        <p class="autor">{{proximo.nmUsuario}}</p>
                        <p class="cargo">{{proximo.dsCargo}}</p>
                    </div>

                </div>
            </div>

        </div>

        <div class="row justify-content-center ">
            <div class="col-12 col-md-8 d-flex justify-content-center txt-p txt-roxo-1 txt-size-35">

                <span @click="prev" class="d-flex align-items-end"><i class="fas fa-caret-left c-pointer"></i></span>
                <span class="mx-3">...</span>
                <span @click="next" class="d-flex align-items-end"><i class="fas fa-caret-right c-pointer"></i></span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Depoimentos',
        data: function () {
            return {
                labels: [
                    "Escute as opiniões de quem já fez parte!",
                ],

                index: 0,

                ativo: null,
                anterior: null,
                proximo: null,

                depoimentos: [
                    {
                        dsDepoimento: '"Vejo o Portal Sollicita como uma ferramenta de grande utilidade e imprescindível para qualquer Órgão Público, ainda mais pela relação custo-benefício. Sempre com matérias diárias de assuntos de grande relevância, e com revistas as revistas Licicon, Negócios Públicos, O Pregoeiro e Governança Pública. Nele também encontramos todas as ferramentas que um servidor da área de licitações necessita, como modelos de editais, orientações, contador de prazos, analisador de balanços, sem contar o acesso aos materiais e videos de Eventos já realizados, como O Congresso Brasileiro de Pregoeiros e o Pregão Week. Inclusive dias atrás tinha uma dúvida a respeito de um assunto e enviei pra eles um questionamento. Para surpresa minha esse questionamento havia virado matéria em menos de uma semana".',
                        nmUsuario: 'Carlos Eduardo Gregorio Pires',
                        dsCargo: 'Chefe da Divisão de Compras UNILA'
                    },

                    {
                        dsDepoimento: '"Num mundo em que a demanda por respostas ágeis e inovadoras da Administração Pública frente às necessidades da sociedade, a atuação das áreas de compras e contratos públicos é posta à prova diariamente. E, neste cenário, o Portal Sollicita se tornou ferramenta de trabalho indispensável para manter a alta performance das equipes, trazendo com rapidez e precisão informações práticas e úteis ao dia a dia do Pregoeiro, Comissões e demais atores em compras públicas, por meio de entrevista com profissionais altamente qualificados, artigos com visão prática e de efetivo uso, além de vasto material de apoio".',
                        nmUsuario: 'Charles Diniz',
                        dsCargo: 'Diretor na área de licitações e contratos e Pregoeiro e Presidente das nas Comissões de Licitações do Tribunal de Justiça do Estado de São Paulo'
                    },

                    {
                        dsDepoimento: '"O Portal Sollicita se consolidou nos últimos anos como uma referência para os agentes de contratação pública em todo o Brasil. Nele, encontramos notícias do momento, bem como artigos e conteúdos mais extensos. Merece destaque especial o Mural dos Professores, onde os melhores instrutores nessa temática no País compartilham apresentações, vídeos e textos".',
                        nmUsuario: 'Cristiano Heckert',
                        dsCargo: 'Secretário de Gestão do Ministério da Economia'
                    },


                ]
            }
        },
        methods: {
            


            prev() {
                if (this.index == 0) {
                    this.index = this.depoimentos.length - 1;
                    
                } else {
                    this.index--;

                    
                }

                this.ativo = this.depoimentos[this.index];

                if (this.index == 0) {
                    this.anterior = this.depoimentos[this.depoimentos.length - 1];
                } else {
                    this.anterior = this.depoimentos[(this.index - 1)];
                }

                if (this.index == this.depoimentos.length - 1) {
                    this.proximo = this.depoimentos[0];
                } else {
                    this.proximo = this.depoimentos[(this.index + 1)];
                }
            },

            next() {

                if ((this.index + 1) == this.depoimentos.length) {
                    this.index = 0;
                } else {
                    this.index++;
                }
                this.ativo = this.depoimentos[this.index];

                if (this.index == 0) {
                    this.anterior = this.depoimentos[this.depoimentos.length - 1];
                } else {
                    this.anterior = this.depoimentos[(this.index - 1)];
                }

                if (this.index == this.depoimentos.length - 1) {
                    this.proximo = this.depoimentos[0];
                } else {
                    this.proximo = this.depoimentos[(this.index + 1)];
                }
            },
        },
        created: function () {
            this.ativo = this.depoimentos[0];
            this.proximo = this.depoimentos[1];
            this.anterior = this.depoimentos[this.depoimentos.length -1];
        }
        
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .depoimentos {
    }
        
    .section-depoimentos .card-depoimento {
        background: #FFFFFF;
        box-shadow: 0px 0px 10px rgba(122, 122, 122, 0.25);
        border-radius: 5px;
        padding: 45px 45px 25px 45px;
        color: #707070;
        text-indent: 25px;
        position: relative;
    }

    .section-depoimentos .card-depoimento .icone-citacao {
        position: absolute;
        z-index: 1;
        top: 10px;
        left: 10px;
        color: #d5d4d470;
        font-size: 60px;
    }

    .section-depoimentos .card-depoimento .depoimento {
        font-size: 16px;
        line-height: 23px;
        text-align: initial;
    }

    .section-depoimentos .card-depoimento .autor {
        font-size: 14px;
        line-height: 16px;
        text-align: right;
        font-weight: bold;
    }

    .section-depoimentos .card-depoimento .cargo {
        text-align: right;
    }

    /* p */

    .section-depoimentos .card-depoimento-p {
        background: #FFFFFF;
        box-shadow: 0px 0px 10px rgba(122, 122, 122, 0.25);
        border-radius: 5px;
        padding: 25px 25px 5px 25px;
        color: #707070;
        position: relative;
    }

        .section-depoimentos .card-depoimento-p .icone-citacao {
            position: absolute;
            z-index: 1;
            top: 10px;
            left: 10px;
            color: #d5d4d470;
            font-size: 20px;
        }

        .section-depoimentos .card-depoimento-p .depoimento {
            font-size: 10px;
            line-height: 10px;
            text-align: initial;
        }

        .section-depoimentos .card-depoimento-p .autor {
            font-size: 10px;
            line-height: 10px;
            text-align: right;
            font-weight: bold;
        }

        .section-depoimentos .card-depoimento-p .cargo {
            text-align: right;
            font-size: 10px;
            line-height: 10px;
        }

</style>

